<!-- <p>rules works!</p> -->

<div class="pageContainer">
    <div class="layoutItem">
        <span style="font-size: large; font-weight: bolder;">Rules</span>
        <span class="flex-spacer"></span>
        <div class="alignRow">
            <mat-icon style="cursor: pointer;" *ngIf="locationHierarchyFilter"
                (click)="filterByLocation($event, true)">close</mat-icon>
            <mat-form-field>
                <mat-label>Filter Location</mat-label>
                <mat-select #locationdropdown [(value)]="locationHierarchyFilter"
                    (selectionChange)="filterByLocation($event)">
                    <mat-option *ngFor="let location of MainLocations as OrganisationsHierarchy" [value]="location">
                        {{ location.Name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </div>

    <div class="layoutItem">
        <ejs-tab id="element" [selectedItem]="selectedTab" (selected)="tabChange($event)">
            <e-tabitems>
                <e-tabitem #rulesTab>
                    <ng-template #headerText>
                        <span class="alignRow app-icon app-icon--rules">
                            <mat-icon />&nbsp;Rules
                        </span>
                    </ng-template>
                    <ng-template #content>
                        <div>
                            <ng-container *ngTemplateOutlet="RulesTab"></ng-container>
                        </div>
                    </ng-template>
                </e-tabitem>
                <e-tabitem #rulesTab>
                    <ng-template #headerText>
                        <span class="alignRow app-icon app-icon--rules">
                            <mat-icon />&nbsp;Assets With No Rules
                        </span>
                    </ng-template>
                    <ng-template #content>
                        <div>
                            <ng-container *ngTemplateOutlet="NoRulesTab"></ng-container>
                        </div>
                    </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>
    </div>
</div>

<ng-template #RulesTab>
    <ng-template #LoadingRules>
        <div class="waiting-container">
            <div class="item">
                <h1>Loading Rules</h1>
            </div>
        </div>
    </ng-template>
    <div style="display: flex; margin-bottom: 0.5em;">
        <span class="toolbar-spacer"></span>
        <span style="font-style: italic;">{{getFilterMessage()}}</span>
    </div>
    <div class="search-div alignRow">
        <div class="search-box">
            <mat-form-field>
                <mat-label>Search for a Rule or Asset</mat-label>
                <input matInput (keyup)="applyRulesFilter($event)" placeholder="" #input>
            </mat-form-field>
        </div>
        <div class="location-dropdown">
            <button mat-raised-button [color]="hasFilters ? 'primary' : undefined" class="filter-button"
                [matMenuTriggerFor]="filterMenuRules">
                <span>Filters</span>
                <mat-icon>tune</mat-icon>
            </button>
        </div>
    </div>
    <ng-container *ngIf="rulesReturned else LoadingRules">
        <table #RuleTable mat-table [dataSource]="rulesDataSource" matSort #rulesSort="matSort"
            [matSortDirection]="'asc'" [matSortActive]="'RuleDescription'">
            <ng-container matColumnDef="RuleDescription" *ngIf="rules">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Rule Name </th>
                <td style="font-weight: bolder;" mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    {{row.RuleDescription}} </td>
            </ng-container>
            <ng-container matColumnDef="condition" *ngIf="rules">
                <th mat-header-cell *matHeaderCellDef> Condition </th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    {{row.ReadableRule}} </td>
            </ng-container>
            <ng-container matColumnDef="AssetName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Asset</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)"> {{
                    row.AssetName }}
                </td>
            </ng-container>
            <ng-container matColumnDef="lastTriggered">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Last Triggered</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <span *ngIf="row.LastTriggered == 0">Never</span>
                    <span *ngIf="row.LastTriggered > 0">{{ convertEpoch(row.LastTriggered) }}</span>
                </td>
            </ng-container>
            <ng-container matColumnDef="eventsInPast30Days">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Events In Past 30 Days</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <span *ngIf="row.EventsInPast30Days == 0">No Events</span>
                    <span *ngIf="row.EventsInPast30Days > 0">{{ row.EventsInPast30Days }}</span>
                </td>
            </ng-container>

            <ng-container matColumnDef="CMMSEnabled">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>CMMS Enabled</th>
                <td mat-cell *matCellDef="let row" (click)="GoToRule(row)">
                    <mat-icon *ngIf="row.CMMSEnabled" style="color: lightgreen;">check</mat-icon>
                    <mat-icon *ngIf="!row.CMMSEnabled" style="color: salmon;">close</mat-icon>
                </td>
            </ng-container>

            <ng-container matColumnDef="buttons">
                <th mat-header-cell *matHeaderCellDef>Options</th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button [matMenuTriggerFor]="RuleOptionsMenu" [matMenuTriggerData]="{ row: row }">
                        <mat-icon>more_horiz</mat-icon>
                    </button>
                    <mat-menu #RuleOptionsMenu>
                        <ng-template matMenuContent let-row="row">
                            <div style="display: grid; grid-template-columns: 1fr; padding: 0.5em; gap: 4px 4px;">
                                <button mat-button (click)="getAssetForRule(row, $event)">
                                    <span>Edit</span>
                                    <mat-icon>edit</mat-icon>
                                </button>
                                <button mat-button (click)="deleteRule(row)">
                                    <span>Delete</span>
                                    <mat-icon style="color: salmon;">delete</mat-icon>
                                </button>
                            </div>
                        </ng-template>
                    </mat-menu>
                </td>
            </ng-container>
            <ng-container matColumnDef="GoToAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToAsset(row)">
                    <mat-icon matTooltip="Go To Asset">north_east</mat-icon>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="filteredRuleColumns"></tr>
            <tr mat-row class="table-row" [ngStyle]="{'color': !row.RuleEnabled ? 'grey' : ''}" style="cursor: pointer;"
                [ngClass]="{'active-rule': row.Active}" *matRowDef="let row; columns: filteredRuleColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td *ngIf="input.value != ''" class="mat-cell" colspan="7">No Data Matching the Filter:
                    "{{input.value}}"</td>
                <td *ngIf="input.value == ''" class="mat-cell" colspan="7">No Data Matching the Filter</td>
            </tr>
        </table>
        <mat-paginator #MatRulePaginator [pageSizeOptions]="[10, 15, 20, 25, 50]" [pageSize]="10"
            aria-label="Select page of rules"></mat-paginator>
    </ng-container>
</ng-template>

<ng-template #NoRulesTab>
    <ng-template #LoadingAssets>
        <div class="waiting-container">
            <div class="item">
                <h1>Loading Assets</h1>
            </div>
        </div>
    </ng-template>
    <div style="display: flex; margin-bottom: 0.5em;">
        <span class="toolbar-spacer"></span>
        <span style="font-style: italic;">{{getLocationMessage()}}</span>
    </div>

    <div class="search-div alignRow">
        <div class="search-box">
            <mat-form-field>
                <mat-label>Search for an Asset</mat-label>
                <input matInput (keyup)="applyAssetFilter($event)" placeholder="" #input>
            </mat-form-field>
        </div>
    </div>
    <ng-container *ngIf="assetsReturned else LoadingAssets">
        <table #AssetTable mat-table [dataSource]="assetsDataSource" matSort #assetsSort="matSort"
            [matSortDirection]="'asc'" [matSortActive]="'Name'">
            <ng-container matColumnDef="Name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Asset Name </th>
                <td style="font-weight: bolder;" mat-cell *matCellDef="let row">
                    {{row.Name}} </td>
            </ng-container>
            <ng-container matColumnDef="Description">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Description </th>
                <td mat-cell *matCellDef="let row">
                    {{row.Description}} </td>
            </ng-container>

            <ng-container matColumnDef="HierarchyPath">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> HierarchyPath </th>
                <td mat-cell *matCellDef="let row">
                    {{row.HierarchyPath}} </td>
            </ng-container>

            <ng-container matColumnDef="Buttons">
                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-raised-button (click)="ManageRules(row)">
                        <!-- <mat-icon>more_horiz</mat-icon> -->
                        <span>Manage</span>
                    </button>
                </td>
            </ng-container>
            <ng-container matColumnDef="GoToAsset">
                <th mat-header-cell *matHeaderCellDef></th>
                <td style="cursor: pointer; font-weight: bolder;" mat-cell *matCellDef="let row"
                    (click)="goToAsset(row)">
                    <mat-icon matTooltip="Go To Asset">north_east</mat-icon>
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="filteredAssetColumns"></tr>
            <tr mat-row class="table-row" *matRowDef="let row; columns: filteredAssetColumns;"></tr>
            <tr class="mat-row" *matNoDataRow>
                <td *ngIf="input.value != ''" class="mat-cell" colspan="6">No Data Matching the Filter:
                    "{{input.value}}"</td>
                <td *ngIf="input.value == ''" class="mat-cell" colspan="6">No Data Matching the Filter</td>
            </tr>
        </table>
        <mat-paginator #MatAssetPaginator [pageSizeOptions]="[10, 15, 20, 25, 50]" [pageSize]="10"
            aria-label="Select page of Assets"></mat-paginator>
    </ng-container>
</ng-template>


<mat-menu #filterMenuRules>
    <div class="filter-switch-div">
        <div class="enabled-switch-div" [ngClass]="{'disabled-checkbox': filterRuleData.Disabled}">
            <span style="margin-right: 0.2em;">Enabled</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="filterEnabledRules($event)"
            [disabled]="filterRuleData.Disabled"></mat-checkbox>

        <div class="enabled-switch-div"
            [ngClass]="{'disabled-checkbox': filterRuleData.Enabled || filterRuleData.Active}">
            <span style="margin-right: 0.2em;">Disabled</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="filterDisabledRules($event)"
            [disabled]="filterRuleData.Enabled || filterRuleData.Active"></mat-checkbox>

        <div class="active-switch-div">
            <span style="margin-right: 0.2em;">CMMS Enabled</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()"
            (change)="filterCMMSRules($event)"></mat-checkbox>

        <div class="active-switch-div" [ngClass]="{'disabled-checkbox': filterRuleData.Disabled}">
            <span style="margin-right: 0.2em;">Active</span>
        </div>
        <mat-checkbox color="primary" (click)="$event.stopPropagation()" (change)="filterActiveRules($event)"
            [disabled]="filterRuleData.Disabled"></mat-checkbox>

    </div>

</mat-menu>